// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app___1xfx_","logo":"App__logo___1I0lU"};


//////////////////
// WEBPACK FOOTER
// ./src/views/App/App.css
// module id = 714
// module chunks = 0